export const RATE_MODAL_TRIGGER_ACTIONS = {
    CONTACT_REVEAL: 'single_contact_reveal',
    SAVE_TO_CRM: 'single_crm_save',
    SAVE_TO_LIST: 'single_list_save',
    SAVE_TO_SEQUENCE: 'single_sequence_save',
    SEND_EMAIL: 'single_email_send',
    BULK_CONTACT_REVEAL: 'bulk_contact_reveal',
    BULK_SAVE_TO_CRM: 'bulk_crm_save',
    BULK_SAVE_TO_LIST: 'bulk_list_save',
    BULK_SAVE_TO_SEQUENCE: 'bulk_sequence_save',
    BULK_SEND_EMAIL: 'bulk_email_send',
};
